import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { ContentControlSubtitlesContainer } from 'app/js/src/domain/content-control/subtitles';
import { SubtitleSegment } from "app/js/src/domain/subtitle-segment";

@Component({
  selector: "evrideo-content-control-studio-subtitle-editor",
  templateUrl: "./content-control-studio-subtitle-editor.component.html",
  styleUrl: "./content-control-studio-subtitle-editor.component.scss",
})
export class ContentControlStudioSubtitleEditorComponent {
  @ViewChild("activeSegmentNumberOneTextarea")
  activeSegmentNumberOneTextarea: ElementRef<HTMLTextAreaElement>;
  @ViewChild("activeSegmentNumberTwoTextarea")
  activeSegmentNumberTwoTextarea: ElementRef<HTMLTextAreaElement>;
  @Input() container: ContentControlSubtitlesContainer;
  @Input() mediaStartTimeStampMs: number = 0;
  @Input("time-format-function") timeFormatFunction!: (
    milliseconds: number,
    fps?: number,
  ) => string;
  public subtitles: Array<string> = [];
  public selectedLanguage: string;
  public segments: Array<SubtitleSegment>;
  public activeSegmentNumberOne: SubtitleSegment;
  public activeSegmentNumberTwo: SubtitleSegment;
  public pageEvent: PageEvent;
  public length = 0;
  public pageSize = 2;
  public pageIndex = 0;
  private pageSubsIndex = 0;

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageIndex = e.pageIndex;
    if (e.previousPageIndex != e.pageIndex) {
      this.pageSubsIndex += e.previousPageIndex < e.pageIndex ? 2 : -2;
    }
    this.setSelectedSegmentsBasedOnPageIndex();
  }

  ngOnInit() {
    this.setupUI();
  }
  ngOnChanges() {
    this.setupUI();
  }
  private setupUI() {
    if (this.container) {
      this.subtitles = this.container.Lanaguages;
      if (this.subtitles.length > 0) {
        this.setSegmentsBasedOnIndex(0);
      }
    }
  }
  adjustHeight(textarea: HTMLTextAreaElement): void {
    textarea.style.height = "auto"; // Reset the height to recalculate
    textarea.style.height = `${textarea.scrollHeight + 5}px`; // Adjust to content's scroll height
  }
  setSegmentsBasedOnIndex(index: number) {
    this.segments = this.container.subtitleSegments(this.subtitles[index]);
    this.length = this.segments.length;
    this.setSelectedSegmentsBasedOnPageIndex();
  }
  setSelectedSegmentsBasedOnPageIndex() {
    let index1 = this.segments[this.pageSubsIndex] ? this.pageSubsIndex : -1;

    let index2 = this.segments[this.pageSubsIndex + 1]
      ? this.pageSubsIndex + 1
      : -1;
    // if (index2 < 0 && this.segments.length > 1) {
    //   index2 = this.segments.length - 1;
    // }
    // if (index1 < 0 && this.segments.length > 2) {
    //   index2 = this.segments.length - 2;
    // }
    this.activeSegmentNumberOne =
      index1 > -1 ? this.segments[index1] : undefined;
    this.activeSegmentNumberTwo =
      index2 > -1 ? this.segments[index2] : undefined;
    setTimeout(() => {
      this.adjustHeight(this.activeSegmentNumberOneTextarea.nativeElement);
      this.adjustHeight(this.activeSegmentNumberTwoTextarea.nativeElement);
    }, 1);
  }
  updateSegmentValue(segment: SubtitleSegment, value) {
    if (segment.Text.includes("\r\n")) {
      // html removes carriage return, so we add it back
      value = value.replaceAll("\n", "\r\n");
    }
    segment.Text = value;
  }
}
